/* ============================================================
   jersey-configurator.js  —  9-step configurator
   Place in: assets/jersey-configurator.js
   ============================================================ */

(function () {
  'use strict';

  const TEXT_ADDON_PRICE = 20;

  // ── IMPORTANT: Back Text Add-on variant ID ──
  // 1. Create a product in Shopify called "Back Text Add-on" priced at €20.00
  // 2. Go to that product → click its single variant → copy the variant ID from the URL
  //    URL looks like: /admin/products/12345/variants/99999999  ← that last number
  // 3. Paste it below replacing 0
  var ADDON_VARIANT_ID = 43438007025753; // Back Text Add-on variant ID

  // ── State ──
  const state = {
    view: 'front',      // starting view chosen in step 1
    color: '#7b0824',
    colorName: 'Red',
    size: 'M',
    logoLeftChest:  'none',
    logoRightChest: 'none',
    logoCentral:    'none',
    nameBack:   '',
    numberBack: '',
    textBack:   '',
  };

  /* ============================================================
     COLOR OPTIONS — add imgFront / imgBack URLs for real photos
  ============================================================ */
  const colorOptions = [
    { value: '#7b0824', name: 'Red',   imgFront: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/jersey-red-front.png',   imgBack: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/jersey-red-back.png' },
    { value: '#1d1d1d', name: 'Black', imgFront: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/jersey-black-front.png', imgBack: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/jersey-black-back.png' },
    { value: '#f25e8f', name: 'Pink',  imgFront: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/jersey-pink-front.png',  imgBack: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/jersey-pink-back.png' },
  ];

  /* ============================================================
     LOGO OPTIONS — Left & Right CHEST only (country/club crests).
     Set img: 'URL' for real images.
  ============================================================ */
  /* ============================================================
   LEFT CHEST LOGOS
============================================================ */

const leftChestLogoOptions = [
{ value: 'none', label: 'None', icon: '∅', img: null },
  // ===== BADGES =====
{ value: 'UAE', label: 'UAE', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/UAE.png' },
{ value: 'ALGERY', label: 'ALGERY', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ALGERY.png' },
{ value: 'ARGENTINA', label: 'ARGENTINA', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ARGENTINA.png' },
{ value: 'BRAZIL', label: 'BRAZIL', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/BRAZIL.png' },
{ value: 'COLOMBIA', label: 'COLOMBIA', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/COLOMBIA.png' },
{ value: 'EGPT', label: 'EGPT', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/EGPT.png' },
{ value: 'ENGLAND', label: 'ENGLAND', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ENGLAND.png' },
{ value: 'FCB', label: 'FCB', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/FCB.png' },
{ value: 'FRANCE', label: 'FRANCE', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/FRANCE.png' },
{ value: 'GHANA', label: 'GHANA', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/GHANA.png' },
{ value: 'IRAQ', label: 'IRAQ', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/IRAQ.png' },
{ value: 'Ivory Coast', label: 'Ivory Coast', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Ivory_Coast.png' },
{ value: 'JORDAN', label: 'JORDAN', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/JORDAN.png' },
{ value: 'LIVER', label: 'LIVER', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/LIVER.png' },
{ value: 'MAN U', label: 'MAN U', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MAN_U.png' },
{ value: 'MAROC', label: 'MAROC', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MAROC.png' },
{ value: 'NETHERLANDS', label: 'NETHERLANDS', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/NETHERLANDS.png' },
{ value: 'NIGERIA', label: 'NIGERIA', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/NIGERIA.png' },
{ value: 'OL', label: 'OL', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OL.png' },
{ value: 'OM', label: 'OM', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OM.png' },
{ value: 'PORTUGAL', label: 'PORTUGAL', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PORTUGAL.png' },
{ value: 'PSG', label: 'PSG', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PSG.png' },
{ value: 'RMD', label: 'RMD', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/RMD.png' },
{ value: 'SENEGAL', label: 'SENEGAL', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SENEGAL.png' },
{ value: 'SPAIN', label: 'SPAIN', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SPAIN.png' },
{ value: 'TUNISIA', label: 'TUNISIA', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/TUNISIA.png' },
{ value: 'TURKEY', label: 'TURKEY', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/TURKEY.png' },

// ===== FLAGS =====
 { value: 'ALGERIA Flag', label: 'ALGERIA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ALGERIA.png?v=1782989917' },
  { value: 'ARGENTINA Flag', label: 'ARGENTINA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ARGENTINA_71f98429-725e-4f8d-bee5-86f3e7fb4488.png' },
  { value: 'BELGIUM Flag', label: 'BELGIUM Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/BELGIUM.png' },
  { value: 'BRAZIL Flag', label: 'BRAZIL Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/BRAZIL_3429c3d0-47ab-4376-ac30-66803a3c1985.png' },
  { value: 'CAMEROON Flag', label: 'CAMEROON Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/CAMEROON.png' },
  { value: 'COLOMBIA Flag', label: 'COLOMBIA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/COLOMBIA_e22372b9-9805-4475-8941-cdea22bfc2e0.png' },
  { value: 'CONGO Flag', label: 'CONGO Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/CONGO.png' },
  { value: 'EGYPT Flag', label: 'EGYPT Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/EGYPT_5c023946-db95-4fac-8d80-58352f1ce88c.png' },
  { value: 'England Flag', label: 'England Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/England_Flag.svg' },
  { value: 'FRANCE Flag', label: 'FRANCE Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/FRANCE_b89ee285-3c6b-400e-b2ef-80ed0f4cfdd0.png' },
  { value: 'GERMANY Flag', label: 'GERMANY Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/GERMANY.png' },
  { value: 'GHANA Flag', label: 'GHANA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/GHANA_7a2257f9-19ce-4bb1-8ecf-9d6c75f1d717.png' },
  { value: 'INDIA Flag', label: 'INDIA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/INDIA.png' },
  { value: 'IRAQ Flag', label: 'IRAQ Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/IRAQ_0a208409-b14d-48b1-9cbe-a53120734b30.png' },
  { value: 'IRELAND Flag', label: 'IRELAND Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/IRELAND.png?v=1782989911' },
  { value: 'ITALY Flag', label: 'ITALY Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ITALY.png' },
  { value: 'IVORY-COAST Flag', label: 'IVORY-COAST Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/IVORY_COAST_54c90632-261f-4e02-88da-c134749d62cc.png' },
  { value: 'JORDAN Flag', label: 'JORDAN Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/JORDAN_78732b7e-28a6-40d0-8bfa-c2e59f212a46.png' },
  { value: 'KURDISTAN Flag', label: 'KURDISTAN Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/KURDISTAN.png' },
  { value: 'LEBANON Flag', label: 'LEBANON Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/LEBANON.png' },
  { value: 'LIBYA Flag', label: 'LIBYA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/LIBYA.png' },
  { value: 'MALI Flag', label: 'MALI Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MALI.png' },
  { value: 'MOROCCO Flag', label: 'MOROCCO Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MOROCCO_4e668449-5ec6-4f99-bd87-9231a5aba920.png' },
  { value: 'NETHERLANDS Flag', label: 'NETHERLANDS Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/NETHERLANDS_488e5232-3398-48c6-b49b-434eb0d73851.png' },
  { value: 'NIGERIA Flag', label: 'NIGERIA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/NIGERIA_18808258-f1f1-4477-a52c-a13257efadca.png' },
  { value: 'PAKISTAN Flag', label: 'PAKISTAN Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PAKISTAN.png' },
  { value: 'PALESTINE Flag', label: 'PALESTINE Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PALESTINE.png' },
  { value: 'PHILIPPINES Flag', label: 'PHILIPPINES Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PHILIPPINES.png' },
  { value: 'PORTUGAL Flag', label: 'PORTUGAL Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PORTUGAL_b16f3346-5c43-4cbe-bae1-d8711d0b2629.png' },
  { value: 'RUSSIA Flag', label: 'RUSSIA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/RUSSIA.png' },
  { value: 'SENEGAL Flag', label: 'SENEGAL Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SENEGAL_1d576fca-838e-4e1c-b0d3-6b596ef52757.png' },
  { value: 'SOUTH-AFRICA Flag', label: 'SOUTH-AFRICA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SOUTH_AFRICA.png' },
  { value: 'SPAIN Flag', label: 'SPAIN Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SPAIN_23eb606d-e310-4b21-8dc3-6793989e3a6a.png' },
  { value: 'SUDAN Flag', label: 'SUDAN Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SUDAN.png' },
  { value: 'SYRIA Flag', label: 'SYRIA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SYRIA.png' },
  { value: 'TUNISIA Flag', label: 'TUNISIA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/TUNSIA.png' },
  { value: 'TURKEY Flag', label: 'TURKEY Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/TURKEY_f64a0988-7fcd-40ee-8ee1-7ae0f4ddfc30.png' },
  { value: 'UAE Flag', label: 'UAE Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/UAE_afef2db0-660a-45ea-a393-174db2038ae1.png' },
  { value: 'UK Flag', label: 'UK Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/UK_Flag.svg' },
  { value: 'USA Flag', label: 'USA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/USA.png' },

// ===== New Logos =====

{ value: '90', label: '90', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/90_e4b44c8b-8cab-4e95-a5c0-b5acbabff687.png' },
{ value: '90-2', label: '90-2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/90_00462cab-7391-4b13-a17e-2956078eecc1.png' },
{ value: 'AMG', label: 'AMG', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/AMG.png' },
{ value: 'JUL 1', label: 'JUL 1', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/JUL_1.png' },
{ value: 'Jul-2', label: 'Jul-2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/JUL_2.png' },
{ value: 'M', label: 'M', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/M.png' },
{ value: 'Omerta', label: 'Omerta', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/omerta_7794e5c8-8e21-426c-bf02-e600a30192cd.png' },
{ value: 'Omerta 2', label: 'Omerta 2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/omerta_2_49746f21-88b2-4219-a064-48d3fbbf03ce.png?v=1784873177' },
{ value: 'OTF', label: 'OTF', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OTF_359ea961-3f30-4d23-a9ad-b70540450789.png' },
{ value: 'OTF-1', label: 'OTF-1', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OTF_1_6bd182c2-3b02-493c-9012-5ad3e92e5711.png' },
{ value: 'OTF-2', label: 'OTF-2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OTF_2_4ac4c166-56ec-4321-96fa-7933c0dd841c.png' },
{ value: 'OVO-1', label: 'OVO-1', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OVO_1.png' },
{ value: 'OVO-2', label: 'OVO-2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OVO_2.png' },
{ value: 'PL', label: 'PL', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PL.png' },
{ value: 'PL 2', label: 'PL 2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PL_2.png' },
{ value: 'ROKSTAR', label: 'ROKSTAR', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ROKSTAR.png' },
{ value: 'ROKSTAR PINK', label: 'ROKSTAR PINK', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ROKSTAR_PINK.png' },
{ value: 'SRT', label: 'SRT', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SRT.png' },
{ value: 'TN', label: 'TN', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/TN.png' },
{ value: 'Morocco Star', label: 'Morocco Star', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/star_of_morocco_603bbe0c-cb86-4e19-be7b-3acc30e44a84.png' },
{ value: 'UCL', label: 'UCL', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/UCL.png' },
{ value: 'UCL-2', label: 'UCL-2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/UCL_2.png' },
{ value: 'FC Palestina', label: 'FC Palestina', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/FC_Palestina.png' },
{ value: 'Zamalek Egypt', label: 'Zamalek Egypt', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Zamalek_Egypt.png' },
{ value: 'AL AHLY', label: 'AL AHLY', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/AL_AHLY.png' },
{ value: 'AL AIN FC', label: 'AL AIN FC', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/AL_AIN_FC.png?' },
{ value: 'Al Widad Morocco', label: 'Al Widad Morocco', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Al_widad_Morocco.png' },
{ value: 'Al Wasl FC', label: 'Al Wasl FC', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Al_Wasl_FC.png' },
{ value: 'Al taraji Tunis', label: 'Al taraji Tunis', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Al_taraji_Tunis.png' },
{ value: 'Al raja Morocco', label: 'Al raja Morocco', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Al_raja_Morocco.png' },
{ value: 'Shabab Al ahli UAE', label: 'Shabab Al ahli UAE', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Shabab_Al_ahli_UAE.png' },
{ value: 'Marseille', label: 'Marseille', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MARSIELLE.png?v=1784873176' },
{ value: 'Chelsea', label: 'Chelsea', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/CHELSEA_b500dbd0-c5ff-425c-a63e-580cf7d1eb57.png?v=1784871194' },
{ value: 'Belgium', label: 'Belgium', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/belgium_23f12fd6-7546-4312-b2e2-45151b7eb522.png?v=1784871191' },
{ value: 'Luffy', label: 'Luffy', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/LUFFY_DUBAI.png?v=1784871194' },
{ value: 'MCA', label: 'MCA', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MCA_ea368e7d-cd60-4cc9-8289-6a39bdb7b923.png?v=1784873180' },
{ value: 'Skull', label: 'Skull', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/skull_bf8afc61-1eb7-4b60-9723-79ad4c15ac4e.png?v=1784873154' },



// ===== CARS =====
{ value: 'BMV 1', label: 'BMV-1', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/BMV_1.png' },
{ value: 'BMV 2', label: 'BMV-2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/BMV_2.png' },
{ value: 'TESLA', label: 'TESLA', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/TESLA.png' },
{ value: 'Volkswagen', label: 'Volkswagen', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Volkswagen.png' },
{ value: 'MERCEDES 1', label: 'MERCEDES-1', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MERCEDES_1.png' },
{ value: 'DODGE', label: 'DODGE', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/DODGE.png' },
{ value: 'FERRARI', label: 'FERRARI', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/FERRARI.png' },
{ value: 'LAMBORGHINI', label: 'LAMBORGHINI', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/LAMBORGHINI.png' },
{ value: 'MERCEDES 2', label: 'MERCEDES-2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MERCEDES_2.png' },
{ value: 'PORSCHE', label: 'PORSCHE', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PORSCHE.png' }
];

/* ============================================================
   RIGHT CHEST LOGOS
============================================================ */

const rightChestLogoOptions = [

{ value: 'none', label: 'None', icon: '∅', img: null },
  // ===== BADGES =====
{ value: 'UAE', label: 'UAE', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/UAE.png' },
{ value: 'ALGERY', label: 'ALGERY', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ALGERY.png' },
{ value: 'ARGENTINA', label: 'ARGENTINA', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ARGENTINA.png' },
{ value: 'BRAZIL', label: 'BRAZIL', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/BRAZIL.png' },
{ value: 'COLOMBIA', label: 'COLOMBIA', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/COLOMBIA.png' },
{ value: 'EGPT', label: 'EGPT', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/EGPT.png' },
{ value: 'ENGLAND', label: 'ENGLAND', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ENGLAND.png' },
{ value: 'FCB', label: 'FCB', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/FCB.png' },
{ value: 'FRANCE', label: 'FRANCE', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/FRANCE.png' },
{ value: 'GHANA', label: 'GHANA', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/GHANA.png' },
{ value: 'IRAQ', label: 'IRAQ', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/IRAQ.png' },
{ value: 'Ivory Coast', label: 'Ivory Coast', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Ivory_Coast.png' },
{ value: 'JORDAN', label: 'JORDAN', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/JORDAN.png' },
{ value: 'LIVER', label: 'LIVER', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/LIVER.png' },
{ value: 'MAN U', label: 'MAN U', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MAN_U.png' },
{ value: 'MAROC', label: 'MAROC', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MAROC.png' },
{ value: 'NETHERLANDS', label: 'NETHERLANDS', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/NETHERLANDS.png' },
{ value: 'NIGERIA', label: 'NIGERIA', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/NIGERIA.png' },
{ value: 'OL', label: 'OL', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OL.png' },
{ value: 'OM', label: 'OM', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OM.png' },
{ value: 'PORTUGAL', label: 'PORTUGAL', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PORTUGAL.png' },
{ value: 'PSG', label: 'PSG', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PSG.png' },
{ value: 'RMD', label: 'RMD', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/RMD.png' },
{ value: 'SENEGAL', label: 'SENEGAL', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SENEGAL.png' },
{ value: 'SPAIN', label: 'SPAIN', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SPAIN.png' },
{ value: 'TUNISIA', label: 'TUNISIA', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/TUNISIA.png' },
{ value: 'TURKEY', label: 'TURKEY', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/TURKEY.png' },

// ===== FLAGS =====
 { value: 'ALGERIA Flag', label: 'ALGERIA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ALGERIA.png?v=1782989917' },
  { value: 'ARGENTINA Flag', label: 'ARGENTINA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ARGENTINA_71f98429-725e-4f8d-bee5-86f3e7fb4488.png' },
  { value: 'BELGIUM Flag', label: 'BELGIUM Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/BELGIUM.png' },
  { value: 'BRAZIL Flag', label: 'BRAZIL Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/BRAZIL_3429c3d0-47ab-4376-ac30-66803a3c1985.png' },
  { value: 'CAMEROON Flag', label: 'CAMEROON Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/CAMEROON.png' },
  { value: 'COLOMBIA Flag', label: 'COLOMBIA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/COLOMBIA_e22372b9-9805-4475-8941-cdea22bfc2e0.png' },
  { value: 'CONGO Flag', label: 'CONGO Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/CONGO.png' },
  { value: 'EGYPT Flag', label: 'EGYPT Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/EGYPT_5c023946-db95-4fac-8d80-58352f1ce88c.png' },
  { value: 'England Flag', label: 'England Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/England_Flag.svg' },
  { value: 'FRANCE Flag', label: 'FRANCE Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/FRANCE_b89ee285-3c6b-400e-b2ef-80ed0f4cfdd0.png' },
  { value: 'GERMANY Flag', label: 'GERMANY Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/GERMANY.png' },
  { value: 'GHANA Flag', label: 'GHANA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/GHANA_7a2257f9-19ce-4bb1-8ecf-9d6c75f1d717.png' },
  { value: 'INDIA Flag', label: 'INDIA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/INDIA.png' },
  { value: 'IRAQ Flag', label: 'IRAQ Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/IRAQ_0a208409-b14d-48b1-9cbe-a53120734b30.png' },
  { value: 'IRELAND Flag', label: 'IRELAND Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/IRELAND.png?v=1782989911' },
  { value: 'ITALY Flag', label: 'ITALY Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ITALY.png' },
  { value: 'IVORY-COAST Flag', label: 'IVORY-COAST Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/IVORY_COAST_54c90632-261f-4e02-88da-c134749d62cc.png' },
  { value: 'JORDAN Flag', label: 'JORDAN Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/JORDAN_78732b7e-28a6-40d0-8bfa-c2e59f212a46.png' },
  { value: 'KURDISTAN Flag', label: 'KURDISTAN Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/KURDISTAN.png' },
  { value: 'LEBANON Flag', label: 'LEBANON Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/LEBANON.png' },
  { value: 'LIBYA Flag', label: 'LIBYA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/LIBYA.png' },
  { value: 'MALI Flag', label: 'MALI Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MALI.png' },
  { value: 'MOROCCO Flag', label: 'MOROCCO Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MOROCCO_4e668449-5ec6-4f99-bd87-9231a5aba920.png' },
  { value: 'NETHERLANDS Flag', label: 'NETHERLANDS Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/NETHERLANDS_488e5232-3398-48c6-b49b-434eb0d73851.png' },
  { value: 'NIGERIA Flag', label: 'NIGERIA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/NIGERIA_18808258-f1f1-4477-a52c-a13257efadca.png' },
  { value: 'PAKISTAN Flag', label: 'PAKISTAN Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PAKISTAN.png' },
  { value: 'PALESTINE Flag', label: 'PALESTINE Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PALESTINE.png' },
  { value: 'PHILIPPINES Flag', label: 'PHILIPPINES Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PHILIPPINES.png' },
  { value: 'PORTUGAL Flag', label: 'PORTUGAL Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PORTUGAL_b16f3346-5c43-4cbe-bae1-d8711d0b2629.png' },
  { value: 'RUSSIA Flag', label: 'RUSSIA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/RUSSIA.png' },
  { value: 'SENEGAL Flag', label: 'SENEGAL Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SENEGAL_1d576fca-838e-4e1c-b0d3-6b596ef52757.png' },
  { value: 'SOUTH-AFRICA Flag', label: 'SOUTH-AFRICA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SOUTH_AFRICA.png' },
  { value: 'SPAIN Flag', label: 'SPAIN Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SPAIN_23eb606d-e310-4b21-8dc3-6793989e3a6a.png' },
  { value: 'SUDAN Flag', label: 'SUDAN Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SUDAN.png' },
  { value: 'SYRIA Flag', label: 'SYRIA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SYRIA.png' },
  { value: 'TUNISIA Flag', label: 'TUNISIA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/TUNSIA.png' },
  { value: 'TURKEY Flag', label: 'TURKEY Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/TURKEY_f64a0988-7fcd-40ee-8ee1-7ae0f4ddfc30.png' },
  { value: 'UAE Flag', label: 'UAE Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/UAE_afef2db0-660a-45ea-a393-174db2038ae1.png' },
  { value: 'UK Flag', label: 'UK Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/UK_Flag.svg' },
  { value: 'USA Flag', label: 'USA Flag', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/USA.png' },

// ===== New Logos =====

{ value: '90', label: '90', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/90_e4b44c8b-8cab-4e95-a5c0-b5acbabff687.png' },
{ value: '90-2', label: '90-2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/90_00462cab-7391-4b13-a17e-2956078eecc1.png' },
{ value: 'AMG', label: 'AMG', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/AMG.png' },
{ value: 'JUL 1', label: 'JUL 1', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/JUL_1.png' },
{ value: 'Jul-2', label: 'Jul-2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/JUL_2.png' },
{ value: 'M', label: 'M', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/M.png' },
{ value: 'Omerta', label: 'Omerta', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/omerta_7794e5c8-8e21-426c-bf02-e600a30192cd.png' },
{ value: 'Omerta 2', label: 'Omerta 2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/omerta_2_49746f21-88b2-4219-a064-48d3fbbf03ce.png?v=1784873177' },
{ value: 'OTF', label: 'OTF', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OTF_359ea961-3f30-4d23-a9ad-b70540450789.png' },
{ value: 'OTF-1', label: 'OTF-1', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OTF_1_6bd182c2-3b02-493c-9012-5ad3e92e5711.png' },
{ value: 'OTF-2', label: 'OTF-2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OTF_2_4ac4c166-56ec-4321-96fa-7933c0dd841c.png' },
{ value: 'OVO-1', label: 'OVO-1', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OVO_1.png' },
{ value: 'OVO-2', label: 'OVO-2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OVO_2.png' },
{ value: 'PL', label: 'PL', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PL.png' },
{ value: 'PL 2', label: 'PL 2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PL_2.png' },
{ value: 'ROKSTAR', label: 'ROKSTAR', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ROKSTAR.png' },
{ value: 'ROKSTAR PINK', label: 'ROKSTAR PINK', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/ROKSTAR_PINK.png' },
{ value: 'SRT', label: 'SRT', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/SRT.png' },
{ value: 'TN', label: 'TN', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/TN.png' },
{ value: 'Morocco Star', label: 'Morocco Star', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/star_of_morocco_603bbe0c-cb86-4e19-be7b-3acc30e44a84.png' },
{ value: 'UCL', label: 'UCL', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/UCL.png' },
{ value: 'UCL-2', label: 'UCL-2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/UCL_2.png' },
{ value: 'FC Palestina', label: 'FC Palestina', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/FC_Palestina.png' },
{ value: 'Zamalek Egypt', label: 'Zamalek Egypt', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Zamalek_Egypt.png' },
{ value: 'AL AHLY', label: 'AL AHLY', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/AL_AHLY.png' },
{ value: 'AL AIN FC', label: 'AL AIN FC', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/AL_AIN_FC.png?' },
{ value: 'Al Widad Morocco', label: 'Al Widad Morocco', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Al_widad_Morocco.png' },
{ value: 'Al Wasl FC', label: 'Al Wasl FC', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Al_Wasl_FC.png' },
{ value: 'Al taraji Tunis', label: 'Al taraji Tunis', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Al_taraji_Tunis.png' },
{ value: 'Al raja Morocco', label: 'Al raja Morocco', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Al_raja_Morocco.png' },
{ value: 'Shabab Al ahli UAE', label: 'Shabab Al ahli UAE', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Shabab_Al_ahli_UAE.png' },
{ value: 'Marseille', label: 'Marseille', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MARSIELLE.png?v=1784873176' },
{ value: 'Chelsea', label: 'Chelsea', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/CHELSEA_b500dbd0-c5ff-425c-a63e-580cf7d1eb57.png?v=1784871194' },
{ value: 'Belgium', label: 'Belgium', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/belgium_23f12fd6-7546-4312-b2e2-45151b7eb522.png?v=1784871191' },
{ value: 'Luffy', label: 'Luffy', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/LUFFY_DUBAI.png?v=1784871194' },
{ value: 'MCA', label: 'MCA', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MCA_ea368e7d-cd60-4cc9-8289-6a39bdb7b923.png?v=1784873180' },
{ value: 'Skull', label: 'Skull', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/skull_bf8afc61-1eb7-4b60-9723-79ad4c15ac4e.png?v=1784873154' },



// ===== CARS =====
{ value: 'BMV 1', label: 'BMV-1', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/BMV_1.png' },
{ value: 'BMV 2', label: 'BMV-2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/BMV_2.png' },
{ value: 'TESLA', label: 'TESLA', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/TESLA.png' },
{ value: 'Volkswagen', label: 'Volkswagen', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Volkswagen.png' },
{ value: 'MERCEDES 1', label: 'MERCEDES-1', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MERCEDES_1.png' },
{ value: 'DODGE', label: 'DODGE', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/DODGE.png' },
{ value: 'FERRARI', label: 'FERRARI', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/FERRARI.png' },
{ value: 'LAMBORGHINI', label: 'LAMBORGHINI', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/LAMBORGHINI.png' },
{ value: 'MERCEDES 2', label: 'MERCEDES-2', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/MERCEDES_2.png' },
{ value: 'PORSCHE', label: 'PORSCHE', img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/PORSCHE.png' }
];

  
  /* ============================================================
     SPONSOR OPTIONS — CENTRAL logo on the FRONT only.
     This is a separate list from logoOptions above.
     Replace/add entries below with your real sponsors:
       value : unique id (sent to the cart as a line item property)
       label : name shown under the logo thumbnail
       img   : URL to the sponsor's logo image (PNG with transparent
               background works best — same as the crest images above)
     Add a new sponsor by copying a line and changing value/label/img.
  ============================================================ */
  const sponsorOptions = [
    { value: 'none',      label: 'None',      icon: '∅', img: null },
    { value: 'GTA', label: 'GTA', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/GTA_98657e73-7f2a-4a96-9405-5325ba974815.png?v=1784871161' },
  { value: 'Dubai', label: 'Dubai', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/DUBAI.png' },
  { value:'City Gang', label: 'City Gang', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/City_Gang.png' },
  { value:'Habibi', label: 'Habibi', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Habibi.png' },
  { value:'UFC', label: 'UFC', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/UFC.png' },
  { value:'Bank Palestine', label: 'Bank Palestine', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/bank_of_palestine.png?v=1784871196' },
  { value:'Alger', label: 'Alger', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Alger.png' },
  { value: 'MOROCCO', label: 'MOROCCO', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Morocco_4c9b03b6-45d7-426e-ae47-2cbc9c6252dd.png' },
  { value:'Almaghrib', label: 'Almaghrib', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Almaghrib.png' },
  { value:'Trapstar', label: 'Trapstar', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/trapstar_88d16cf0-5ffe-422c-91e4-d760e8f5165d.png?v=1784873156' },
  { value:'Mafia', label: 'Mafia', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Mafia.png' },
  { value: '4PF', label: '4PF', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/4PF_3c4437cd-991c-4074-ad52-d0d28ef5c84c.png' }, // Redbull not present
  { value: 'TN AIR', label: 'TN AIR', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/TN_AIR.png' },
  { value: 'JUL', label: 'JUL', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/jul.png' },
  { value: 'OTF', label: 'OTF', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OTF_9f5f09a6-e672-45fc-844f-682bedc0b74e.png' },
  { value:'OMERTA', label: 'OMERTA', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OMERTA.png' },
  { value: 'EGYPT AIR', label: 'EGYPT AIR', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/EgyptAir.png' },
  { value: 'VENUM', label: 'VENUM', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/venum_938a7bb3-6f5d-452f-8600-d5933f6aaa60.png' },
  { value: 'Banque de Liban', label: 'Banque de Liban', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/banque_de_liban_c15d52cc-2a82-450a-af12-4df1f5d1cc63.png' },
  { value: 'IRAQI', label: 'IRAQI', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/iraqi_airways.png' },
  { value: 'Banque De Misr', label: 'Banque De Misr', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/banque_de_misr.png' },
  { value: 'Yeezy', label: 'Yeezy', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/yeezy.png' },
  { value: '2PAC', label: '2PAC', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/2PAC.png' },
  { value: 'OTF-2', label: 'OTF-2', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OTF_2.png' },
  { value: '90', label: '90', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/90.png' },
  { value: 'OTF-1', label: 'OTF-1', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/OTF_1.png' },
  { value: 'WANTED', label: 'WANTED', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/WANTED.png' },
  { value: 'Joga Bonito', label: 'Joga Bonito', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/joga_bonito.png' },
  { value:'Air_Algerie', label: 'Air_Algerie', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Air_Algerie.png' },
  { value:'One Piece', label: 'One Piece', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/One_piece.png' },
  { value:'Pali Map', label: 'Pali Map', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/Pali_map.png' },
  { value:'QLF', label: 'QLF', icon: null, img: 'https://cdn.shopify.com/s/files/1/0738/9275/7593/files/QLF.png' }

  ];

  function hasRealImages() {
    return colorOptions.some(function(c) { return c.imgFront || c.imgBack; });
  }

  // ── Step routing ──
  //
  // FRONT start:  1 → 2 → 3 → 4 → 5 → 6 → 7 → 8 → 9
  //               View  Color Size  LL   RL   CL   Name Num  Text
  //               (preview flips to FRONT after step 1, to BACK after step 6)
  //
  // BACK start:   1 → 2 → 3 → 4 → 5 → 6 → 7 → 8 → 9
  //               View  Color Size  LL   RL   CL   Name Num  Text
  //               (preview shows BACK at step 1, flips to FRONT at step 4,
  //                back to BACK at step 7)
  //
  // Both paths go through ALL 9 steps in the same order.
  // The only difference is which side the preview shows at each point.

  function getStepList() {
    // Always all 9 steps regardless of starting view
    return [1, 2, 3, 4, 5, 6, 7, 8, 9];
  }

  let currentStep = 1;
  // Manual override set by clicking the Front/Back tabs above the preview.
  // null = use the step's default side (previewSideForStep). Cleared
  // whenever the user moves to a different step via Back/Next.
  let manualPreviewSide = null;

  function getNextStep() {
    const steps = getStepList();
    const idx = steps.indexOf(currentStep);
    return idx < steps.length - 1 ? steps[idx + 1] : null;
  }
  function getPrevStep() {
    const steps = getStepList();
    const idx = steps.indexOf(currentStep);
    return idx > 0 ? steps[idx - 1] : null;
  }

  // ── Which preview side to show at each step ──
  // When started from FRONT: front for steps 1-6, back for 7-9
  // When started from BACK:  back for steps 1-3, front for 4-6, back for 7-9
  function previewSideForStep(step) {
    if (step >= 7) return 'back';
    if (step >= 4) return 'front';
    // Steps 1-3: show the side the customer chose
    return state.view;
  }

  // ── Render color swatches ──
  function renderColorSwatches() {
    const container = document.getElementById('jc-color-swatches');
    if (!container) return;
    container.innerHTML = colorOptions.map(c => `
      <button class="jc-color-swatch ${c.value === state.color ? 'active' : ''}"
              data-color="${c.value}" data-name="${c.name}"
              style="background:${c.value}" title="${c.name}">
        <span class="jc-color-swatch__check">&#10003;</span>
      </button>
    `).join('');
    container.querySelectorAll('.jc-color-swatch').forEach(btn => {
      btn.addEventListener('click', function () {
        state.color     = this.dataset.color;
        state.colorName = this.dataset.name;
        renderColorSwatches();
        const label = document.getElementById('jc-color-name');
        if (label) label.textContent = state.colorName;
        updatePreview();
      });
    });
  }

  // ── Render logo grids (used for left chest, right chest, and the
  //     central/sponsor grid — each is passed its own options list) ──
  function renderLogoGrid(containerId, stateKey, options) {
    const container = document.getElementById(containerId);
    if (!container) return;
    container.innerHTML = options.map(opt => `
      <label class="jc-badge-option ${state[stateKey] === opt.value ? 'active' : ''}"
             data-badge="${opt.value}">
        <input type="radio" name="${stateKey}" value="${opt.value}"
               ${state[stateKey] === opt.value ? 'checked' : ''}>
        <div class="jc-badge-option__preview">
          ${opt.img
            ? `<img src="${opt.img}" alt="${opt.label}" style="width:38px;height:38px;object-fit:contain;">`
            : `<span class="jc-badge-option__icon">${opt.icon}</span>`}
        </div>
        <span class="jc-badge-option__name">${opt.label}</span>
      </label>
    `).join('');
    container.querySelectorAll('.jc-badge-option').forEach(opt => {
      opt.addEventListener('click', function () {
        state[stateKey] = this.dataset.badge;
        renderLogoGrid(containerId, stateKey, options);
        updatePreview();
      });
    });
  }

  // ── Price ──
  function updatePrice() {
    const baseEl  = document.getElementById('jc-base-price-val');
    const addEl   = document.getElementById('jc-addon-price');
    const totalEl = document.getElementById('jc-total-price');
    if (!baseEl) return;
    const baseCents = parseInt(baseEl.dataset.cents, 10) || 0;
    const baseVal   = baseCents / 100;
    const addon     = state.textBack.trim().length > 0 ? TEXT_ADDON_PRICE : 0;
    const total     = baseVal + addon;
    if (addEl) {
      addEl.style.display = addon > 0 ? 'flex' : 'none';
      var addonPriceEl = addEl.querySelector('.jc-price--addon');
      if (addonPriceEl) {
        addonPriceEl.textContent = '+AED ' + TEXT_ADDON_PRICE.toFixed(2);
      }
    }
    if (totalEl) totalEl.textContent = 'AED ' + total.toFixed(2);
  }

  // ── updatePreview ──
  function updatePreview() {
    var previewSide = manualPreviewSide || previewSideForStep(currentStep);
    var isFront     = previewSide === 'front';
    var color       = state.color;
    var active      = colorOptions.find(function(c) { return c.value === color; });
    var useImgs     = hasRealImages();

    // Sync preview tab highlight
    document.querySelectorAll('.jc-preview__tab').forEach(function(t) {
      t.classList.toggle('active', t.dataset.previewSide === previewSide);
    });

    var frontSvg   = document.getElementById('jc-jersey-front');
    var backSvg    = document.getElementById('jc-jersey-back');
    var photoWrap  = document.getElementById('jc-photo-wrap');
    var frontPhoto = document.getElementById('jc-jersey-photo-front');
    var backPhoto  = document.getElementById('jc-jersey-photo-back');

    if (useImgs && active) {
      // Photo mode
      if (frontSvg)  frontSvg.style.display = 'none';
      if (backSvg)   backSvg.style.display  = 'none';
      if (photoWrap) photoWrap.style.display = 'block';
      if (frontPhoto) {
        if (active.imgFront) frontPhoto.src = active.imgFront;
        frontPhoto.style.display = isFront ? 'block' : 'none';
      }
      if (backPhoto) {
        if (active.imgBack) backPhoto.src = active.imgBack;
        backPhoto.style.display = isFront ? 'none' : 'block';
      }
      // Photo back text overlays
      var pName = document.getElementById('jc-back-name-text-photo');
      var pNum  = document.getElementById('jc-back-number-text-photo');
      var pTxt  = document.getElementById('jc-back-extra-text-photo');
      if (pName) { pName.textContent = state.nameBack.toUpperCase();  pName.style.display = (!isFront && state.nameBack)   ? 'block' : 'none'; }
      if (pNum)  { pNum.textContent  = state.numberBack;              pNum.style.display  = (!isFront && state.numberBack) ? 'block' : 'none'; }
      if (pTxt)  { pTxt.textContent  = state.textBack.toUpperCase();  pTxt.style.display  = (!isFront && state.textBack)   ? 'block' : 'none'; }
    } else {
      // SVG mode
      if (photoWrap) photoWrap.style.display = 'none';
      if (frontSvg)  frontSvg.style.display  = isFront ? 'block' : 'none';
      if (backSvg)   backSvg.style.display   = isFront ? 'none'  : 'block';
      ['jc-front-body','jc-front-sleeve-l','jc-front-sleeve-r',
       'jc-back-body', 'jc-back-sleeve-l', 'jc-back-sleeve-r'].forEach(function(id) {
        var el = document.getElementById(id);
        if (el) el.setAttribute('fill', color);
      });
      var sName = document.getElementById('jc-back-name-text-svg');
      var sNum  = document.getElementById('jc-back-number-text-svg');
      var sTxt  = document.getElementById('jc-back-extra-text-svg');
      if (sName) sName.textContent = state.nameBack.toUpperCase();
      if (sNum)  sNum.textContent  = state.numberBack;
      if (sTxt)  sTxt.textContent  = state.textBack.toUpperCase();
    }

    // Logo overlays — front logos only shown when preview is front.
    // Left/right chest pull from logoOptions (crests); central pulls
    // from sponsorOptions (sponsor logos).
  [
  [
    'jc-logo-left-chest',
    state.logoLeftChest,
    isFront,
    leftChestLogoOptions
  ],

  [
    'jc-logo-right-chest',
    state.logoRightChest,
    isFront,
    rightChestLogoOptions
  ],

  [
    'jc-logo-central',
    state.logoCentral,
    isFront,
    sponsorOptions
  ],

].forEach(function(pair) {
      var el   = document.getElementById(pair[0]);
      var val  = pair[1];
      var show = pair[2] && val !== 'none';
      var opts = pair[3];
      if (!el) return;
     var opt = (opts || []).find(function(o) {
    return o.value === val;
});

if (!opt) {
    el.style.display = 'none';
    return;
}
      if (opt && opt.img) {
        el.innerHTML = '<img src="' + opt.img + '" alt="' + (opt.label || '') + '">';
      } else {
        el.textContent = (opt && opt.icon && opt.icon !== '∅') ? opt.icon : '';
      }
      el.style.display = show ? 'flex' : 'none';
    });

    // Summary strip
    var dot = document.getElementById('jc-sum-color');
    if (dot) dot.style.background = color;
    var sumTxt = document.getElementById('jc-sum-text');
    if (sumTxt) sumTxt.textContent = state.colorName + ' · Size ' + state.size;

    updatePrice();
  }

  // ── Step transition banners ──
  // Show contextual message when preview flips
  function updateTransitionBanner(step) {
    var banner = document.getElementById('jc-transition-banner');
    if (!banner) return;

    // Step 4 when started from back → "Now let's customise the front"
    if (step === 4 && state.view === 'back') {
      banner.textContent = '✦ Switched to Front view — choose your chest logos';
      banner.style.display = 'block';
    // Step 7 → "Now the back"
    } else if (step === 7) {
      banner.textContent = '✦ Switched to Back view — add name, number & text';
      banner.style.display = 'block';
    } else {
      banner.style.display = 'none';
    }
  }

  // ── goToStep ──
  function goToStep(step) {
    currentStep = step; // MUST be first — getNextStep/getPrevStep depend on it
    manualPreviewSide = null; // reset any manual Front/Back tab override

    document.querySelectorAll('.jc-panel').forEach(function(p) {
      p.classList.remove('active');
    });
    var target = document.querySelector('.jc-panel[data-panel="' + step + '"]');
    if (target) target.classList.add('active');

    var steps = getStepList();
    var pos   = steps.indexOf(step) + 1;
    var total = steps.length;

    var bar = document.getElementById('jc-progress-fill');
    if (bar) bar.style.width = (total > 1 ? ((pos - 1) / (total - 1)) * 100 : 100) + '%';

    var counter = document.getElementById('jc-current-step');
    if (counter) counter.textContent = 'Step ' + pos + ' of ' + total;

    var isLast  = getNextStep() === null;
    var hasPrev = getPrevStep() !== null;

    var backBtn = document.getElementById('jc-back');
    var nextBtn = document.getElementById('jc-next');
    var atcWrap = document.getElementById('jc-atc-wrap');
    var navBar  = document.getElementById('jc-nav');

    if (backBtn) backBtn.style.display = hasPrev ? 'block' : 'none';
    if (nextBtn) nextBtn.style.display = isLast  ? 'none'  : 'block';
    if (atcWrap) atcWrap.style.display = isLast  ? 'block' : 'none';
    // FIX: the nav bar (which holds the Back button) must stay visible
    // on every step, including the last one — Back/Next are controlled
    // individually above, so the bar itself should never be hidden.
    if (navBar)  navBar.style.display  = 'flex';

    updateTransitionBanner(step);
    updatePreview(); // uses previewSideForStep(currentStep) internally
  }

  // ── Navigation ──
  var nextBtn = document.getElementById('jc-next');
  var backBtn = document.getElementById('jc-back');

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      var next = getNextStep();
      if (next) goToStep(next);
    });
  }
  if (backBtn) {
    backBtn.addEventListener('click', function() {
      var prev = getPrevStep();
      if (prev) goToStep(prev);
    });
  }

  // ── Step 1: View selection ──
  document.querySelectorAll('.jc-view-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      state.view = this.dataset.view;
      document.querySelectorAll('.jc-view-btn').forEach(function(b) {
        b.classList.remove('active');
      });
      this.classList.add('active');
      updatePreview();
    });
  });

  // ── Preview tab buttons (manual override) ──
  document.querySelectorAll('.jc-preview__tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      // Set the override and let updatePreview() handle svg/photo AND
      // logo/back-text overlays consistently, instead of duplicating
      // display logic here (which previously fell out of sync).
      manualPreviewSide = this.dataset.previewSide;
      updatePreview();
    });
  });

  // ── Step 3: Size ──
  document.querySelectorAll('.jc-size-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      state.size = this.dataset.size;
      document.querySelectorAll('.jc-size-btn').forEach(function(b) {
        b.classList.remove('active');
      });
      this.classList.add('active');
      var sv = document.getElementById('jc-size-value');
      if (sv) sv.value = state.size;
      updatePreview();
    });
  });

  // ── Step 7: Name ──
  var nameInput = document.getElementById('jc-input-name');
  if (nameInput) {
    nameInput.addEventListener('input', function() {
      state.nameBack = this.value;
      var c = document.getElementById('jc-name-count');
      if (c) c.textContent = this.value.length;
      updatePreview();
    });
  }

  // ── Step 8: Number (digits only, max 3) ──
  var numInput = document.getElementById('jc-input-number');
  if (numInput) {
    numInput.addEventListener('input', function() {
      this.value       = this.value.replace(/[^0-9]/g, '').slice(0, 3);
      state.numberBack = this.value;
      updatePreview();
    });
  }

  // ── Step 9: Back text (max 16) ──
  var txtInput = document.getElementById('jc-input-text');
  if (txtInput) {
    txtInput.addEventListener('input', function() {
      if (this.value.length > 16) this.value = this.value.slice(0, 16);
      state.textBack = this.value;
      var c = document.getElementById('jc-text-count');
      if (c) c.textContent = this.value.length;
      updatePreview();
      updatePrice();
    });
  }

  // ════════════════════════════════════════════════════
  // ADD TO CART / BUY NOW
  // ════════════════════════════════════════════════════

  var atcBtn = document.getElementById('jc-atc-btn');
  if (atcBtn) {
    atcBtn.addEventListener('click', function() { doAddToCart(); });
  }

  var buyNowBtn = document.getElementById('jc-buynow-btn');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function() { doBuyNow(); });
  }

  // Builds the jersey line-item properties from current state.
  function buildJerseyProps() {
    var sponsorOpt = sponsorOptions.find(function(o) { return o.value === state.logoCentral; });
    var props = {
      'View':   state.view === 'front' ? 'Front' : 'Back',
      'Colour': state.colorName,
      'Size':   state.size
    };
    if (state.logoLeftChest  !== 'none') props['Left Chest']   = state.logoLeftChest;
    if (state.logoRightChest !== 'none') props['Right Chest']  = state.logoRightChest;
    if (state.logoCentral    !== 'none') props['Sponsor (Center Front)'] = (sponsorOpt && sponsorOpt.label) || state.logoCentral;
    if (state.nameBack.trim())           props['Name']         = state.nameBack.trim().toUpperCase();
    if (state.numberBack.trim())         props['Number']       = state.numberBack.trim();
    // NOTE: Back Text is intentionally NOT added as a jersey property here.
    // It's sent as a property on the add-on line item instead (see
    // addConfiguredItemsToCart below) so the text and its AED 20 charge
    // live on the SAME cart line. If the customer removes the add-on
    // line on the cart page, the text note disappears with it instead
    // of being left behind (orphaned) on the jersey line.
    return props;
  }

  // Shared logic used by both "Add to Cart" and "Buy Now": posts the
  // jersey (and the back-text add-on, if needed) to the cart.
  // callback(success, errorMessage, opts) — opts.partial is true when
  // the jersey was added but the add-on charge failed.
  function addConfiguredItemsToCart(callback) {
    var store     = document.getElementById('jc-variant-store');
    var variantId = store ? parseInt(store.getAttribute('data-variant'), 10) : 0;

    if (!variantId || variantId === 0) {
      callback(false, 'Product variant not found. Please refresh the page.');
      return;
    }

    var props      = buildJerseyProps();
    var hasText    = state.textBack.trim().length > 0;
    var needsAddon = hasText && ADDON_VARIANT_ID > 0;

    if (hasText && ADDON_VARIANT_ID === 0) {
      callback(false, 'Back text add-on not configured. Set ADDON_VARIANT_ID in jersey-configurator.js.');
      return;
    }

    // POST 1: Jersey
    cartPost({ id: variantId, quantity: 1, properties: props }, function(ok1, resp1) {
      console.log('[JC] Jersey POST:', ok1, resp1);
      if (!ok1) {
        callback(false, (resp1 && (resp1.description || resp1.message)) || 'Could not add jersey to cart.');
        return;
      }
      if (!needsAddon) {
        callback(true);
        return;
      }
      // POST 2: back-text add-on — the text lives on THIS line so removing
      // the add-on on the cart page removes the text note with it.
      console.log('[JC] Posting addon, id =', ADDON_VARIANT_ID, ' price =', TEXT_ADDON_PRICE);
      cartPost({ id: ADDON_VARIANT_ID, quantity: 1, properties: {
        'For':       'Back text',
        'Back Text': state.textBack.trim().toUpperCase()
      } }, function(ok2, resp2) {
        console.log('[JC] Addon POST:', ok2, resp2);
        if (!ok2) {
          callback(false,
            (resp2 && (resp2.description || resp2.message)) ||
            'Jersey added but back text charge failed. Please contact us.',
            { partial: true });
          return;
        }
        callback(true);
      });
    });
  }

  function doAddToCart() {
    var btn       = document.getElementById('jc-atc-btn');
    var btnText   = document.getElementById('jc-atc-btn-text');
    var btnIcon   = document.getElementById('jc-atc-btn-icon');
    var errEl     = document.getElementById('jc-cart-error');
    var successEl = document.getElementById('jc-cart-success');

    // Loading
    btn.disabled        = true;
    btnText.textContent = 'Adding\u2026';
    btnIcon.textContent = '';
    if (errEl)     errEl.style.display     = 'none';
    if (successEl) successEl.style.display = 'none';

    addConfiguredItemsToCart(function(success, errMsg, opts) {
      if (!success) {
        showErr(errEl, btn, btnText, btnIcon, errMsg);
        if (opts && opts.partial) {
          // Jersey made it into the cart even though the add-on failed —
          // reset the button label back to normal rather than "Adding…".
          btn.disabled        = false;
          btnText.textContent = 'Add to Cart';
          btnIcon.textContent = '\u2192';
        }
        return;
      }
      cartDone(btn, btnText, btnIcon, successEl);
    });
  }

  // Buy Now: same cart logic as Add to Cart, but on success skips the
  // cart page entirely and sends the customer straight to checkout.
  function doBuyNow() {
    var btn     = document.getElementById('jc-buynow-btn');
    var btnText = document.getElementById('jc-buynow-btn-text');
    var btnIcon = document.getElementById('jc-buynow-btn-icon');
    var errEl   = document.getElementById('jc-cart-error');
    var atcBtnEl = document.getElementById('jc-atc-btn');

    // Loading — disable both buttons so the customer can't double-submit
    btn.disabled          = true;
    btnText.textContent   = 'Redirecting\u2026';
    if (btnIcon) btnIcon.textContent = '';
    if (atcBtnEl) atcBtnEl.disabled  = true;
    if (errEl) errEl.style.display   = 'none';

    addConfiguredItemsToCart(function(success, errMsg) {
      if (!success) {
        showErr(errEl, btn, btnText, btnIcon, errMsg);
        btnText.textContent = 'Buy Now';
        if (atcBtnEl) atcBtnEl.disabled = false;
        return;
      }
      // Send the customer straight to checkout, bypassing the cart page.
      window.location.href = '/checkout';
    });
  }

  function cartPost(payload, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept',       'application/json');
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) return;
      var data = null;
      try { data = JSON.parse(xhr.responseText); } catch(e) {}
      console.log('[JC] cartPost response', xhr.status, ':', xhr.responseText.substring(0, 300));
      callback(xhr.status === 200, data);
    };
    xhr.onerror = function() { callback(false, { description: 'Network error' }); };
    xhr.send(JSON.stringify(payload));
  }

  function cartDone(btn, btnText, btnIcon, successEl) {
    btnText.textContent  = '\u2713 Added to cart!';
    btnIcon.textContent  = '';
    btn.disabled         = false;
    btn.style.background = '#00e676';
    btn.style.color      = '#000';
    if (successEl) successEl.style.display = 'block';
    setTimeout(function() {
      btnText.textContent  = 'Add to Cart';
      btnIcon.textContent  = '\u2192';
      btn.style.background = '';
      btn.style.color      = '';
      if (successEl) successEl.style.display = 'none';
    }, 3000);
    refreshCartBubble();
  }

  function showErr(errEl, btn, btnText, btnIcon, msg) {
    if (errEl)   { errEl.textContent = '\u2717 ' + msg; errEl.style.display = 'block'; }
    if (btn)     { btn.disabled = false; btn.style.background = ''; btn.style.color = ''; }
    if (btnText) btnText.textContent = 'Add to Cart';
    if (btnIcon) btnIcon.textContent = '\u2192';
  }

  function refreshCartBubble() {
    var xc = new XMLHttpRequest();
    xc.open('GET', '/cart.js', true);
    xc.setRequestHeader('Accept', 'application/json');
    xc.onreadystatechange = function() {
      if (xc.readyState !== 4 || xc.status !== 200) return;
      try {
        var cart  = JSON.parse(xc.responseText);
        var count = cart.item_count || 0;
        document.querySelectorAll(
          '.cart-count-bubble, [data-cart-count], .header__cart-count'
        ).forEach(function(el) {
          el.textContent = count;
          if (count > 0) { el.removeAttribute('hidden'); el.style.display = ''; }
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch(ex) {}
    };
    xc.send();
  }

  // ── Init ──
  renderColorSwatches();
renderLogoGrid(
  'jc-logo-left-grid',
  'logoLeftChest',
  leftChestLogoOptions
);

renderLogoGrid(
  'jc-logo-right-grid',
  'logoRightChest',
  rightChestLogoOptions
);

renderLogoGrid(
  'jc-logo-central-grid',
  'logoCentral',
  sponsorOptions
);
  updatePreview();
  goToStep(1);

})();
